<template>
  <div class="agenda-box">
    <div class="agenda-top">大会议程</div>
    <div class="agenda-date-tabs flex">
      <div
        class="agenda-date-tab flex cs"
        :class="{ active: dateIndex === activeDateIndex }"
        v-for="(agenda, dateIndex) in currentAgendaList"
        :key="dateIndex"
        @click="didClick_Date(dateIndex)"
      >
        <span class="day flex align-center">{{ agenda.day }}</span>
        <span class="month flex align-center"
          >{{ agenda.month }}<br />{{ agenda.year }}</span
        >
      </div>
    </div>
    <div
      class="agenda-list-box flex"
      v-if="currentAgendaList.length > 0 && currentAgendaList[activeDateIndex]"
    >
      <div class="agenda-type-list-pc">
        <div
          class="agenda-type"
          @click="didClick_Type(index, type)"
          :key="index"
          :class="{ active: index === activeTypeIndex }"
          v-for="(type, index) in currentAgendaList[activeDateIndex].subs2"
        >
          <div v-if="index === activeTypeIndex" class="active-border"></div>
          {{ type.type }}
        </div>
      </div>
      <div class="agenda-type-list-wap">
        <div class="agenda-type-box">
          <div
            class="agenda-type"
            @click="didClick_Type(index, type)"
            :key="index"
            :class="{ active: index === activeTypeIndex }"
            v-for="(type, index) in currentAgendaList[activeDateIndex].subs2"
          >
            <div class="active-bg" v-if="index === activeTypeIndex"></div>
            <div class="active-bottom"></div>
            <img
              class="tab-bg"
              src="../../assets/images/partner/wap/tab-bg.png"
            />
            {{ type.type }}
          </div>
        </div>
      </div>
      <div class="agenda-list-container">
        <div class="special-container">
          <div class="special-box">
            <div class="item-box">
              <div class="item-content">
                <div class="title">
                  {{ currentAgenda.i_meetTitle }}
                </div>
                <div class="content flex">
                  <div class="time flex align-center">
                    <img
                      class="icon"
                      src="../../assets/images/agenda/time.png"
                    />
                    <div class="text ellipsis-1">
                      {{ currentAgenda.startTime | timePipe }}-{{
                        currentAgenda.endTime | timePipe
                      }}
                    </div>
                  </div>
                  <div class="address flex align-start">
                    <img
                      class="icon start_icon"
                      src="../../assets/images/agenda/address.png"
                    />
                    <div class="text">{{ currentAgenda.hotel }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-content-box">
              <div
                class="agenda-list"
                v-if="currentAgenda.agendaList && currentAgenda.agendaList[0]"
              >
                <div
                  class="agenda"
                  :key="index"
                  v-for="(agenda, index) in currentAgenda.agendaList[0].agendas"
                >
                  <div class="agenda-time-box">
                    <div class="agenda-time">
                      <div class="dot"></div>
                      {{ agenda.startTime | timePipe }}-{{
                        agenda.endTime | timePipe
                      }}
                    </div>
                  </div>
                  <div class="agenda-content">
                    <div class="title" v-html="agenda.name"></div>
                    <div class="child-list">
                      <div class="peoples">
                        <div
                          class="people flex flex-direction"
                          :key="guestIndex"
                          v-for="(guest, guestIndex) in agenda.guests"
                        >
                          <div class="info flex">
                            <div class="name">
                              <span
                                :class="{ between: guest.name.length < 3 }"
                                >{{ guest.name }}</span
                              >
                            </div>
                            <div class="postiton">{{ guest.duty }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end tips">*以实际议程为准</div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState } from "vuex";
const fn = () => {
  const el = document.getElementsByClassName("agenda-type-list-wap")[0];
  if (el && el.style) {
    if (el.style.overflowX === "auto") {
      el.style.overflowX = "";
    } else {
      el.style.overflowX = "auto";
    }
  }
};

export default {
  name: "Special",
  props: {
    agendaList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
    if (this.$store.state.isMobile) {
      window.onscroll = () => {
        this.currentAgendaList = this.agendaList.filter((agenda) => {
          let dateAgendaCount = 0;
          agenda.subs2.forEach((subAgenda) => {
            dateAgendaCount += subAgenda.list.length;
          });
          return dateAgendaCount > 0;
        });
        if (this.currentAgendaList[this.activeDateIndex]) {
          this.currentAgenda =
            this.currentAgendaList[this.activeDateIndex].subs2[
              this.activeTypeIndex
            ].list[0];
        }
      };
    } else {
      this.currentAgendaList = this.agendaList.filter((agenda) => {
        let dateAgendaCount = 0;
        agenda.subs2.forEach((subAgenda) => {
          dateAgendaCount += subAgenda.list.length;
        });
        return dateAgendaCount > 0;
      });
      if (this.currentAgendaList[this.activeDateIndex]) {
        this.currentAgenda =
          this.currentAgendaList[this.activeDateIndex].subs2[
            this.activeTypeIndex
          ].list[0];
      }
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.ready = true;
      }, 300);
    });
    //setInterval(fn, 300);
  },
  filters: {
    timePipe(timestamp) {
      return dayjs(timestamp * 1000).format("HH:mm");
    },
  },
  data() {
    return {
      ready: false,
      currentAgendaList: [
        { type: "主题演讲", agendaList: [] },
        { type: "主题演讲", agendaList: [] },
        { type: "主题演讲", agendaList: [] },
      ],
      currentAgenda: {},
      activeDateIndex: 0, //默认日期下标
      activeTypeIndex: 0, //默认类型下标
    };
  },
  methods: {
    didClick_Date(idx) {
      if (idx !== this.activeDateIndex) {
        this.activeDateIndex = idx;
        this.activeTypeIndex = 0;
        this.currentAgenda =
          this.currentAgendaList[this.activeDateIndex].subs2[
            this.activeTypeIndex
          ].list[0];
      }
    },
    didClick_Type(idx, option) {
      //埋码
      window._hw("send", "action", "branch_venue_page_sub_forum_click", {
        agenda_name: option.list[0].name,
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      if (idx !== this.activeTypeIndex) {
        this.activeTypeIndex = idx;
        this.currentAgenda =
          this.currentAgendaList[this.activeDateIndex].subs2[
            this.activeTypeIndex
          ].list[0];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@-moz-document url-prefix() {
  * {
    scrollbar-width: thin;
  }
}

@media (min-width: 992px) {
  [class$="-wap"] {
    display: none;
  }
  .agenda-box {
    width: 1500px;
    margin-top: 50px;
    .agenda-top {
      font-size: 32px;
      font-family: Microsoft YaHei-Light;
      font-weight: bold;
      width: 130px;
      padding-bottom: 15px;
      background: url("../../assets/images/parallelSessions/title-border-pc.png");
      background-size: 130px 5px;
      background-repeat: no-repeat;
      background-position: bottom;
    }
    .agenda-date-tabs {
      margin-top: 25px;
      padding-bottom: 20px;
      border-bottom: 2px solid rgba(221, 221, 221, 0.2);

      .agenda-date-tab {
        color: #999999;
        height: 36px;
        padding-left: 12px;
        border-left: 3px solid transparent;

        &:not(:first-child) {
          margin-left: 48px;
        }
        .day {
          height: 100%;
          font-size: 38px;
          font-family: Microsoft YaHei-Light;
          font-weight: 900;
        }
        .month {
          margin-left: 10px;
          padding-left: 20px;
          height: 100%;
          font-size: 15px;
          font-family: Microsoft YaHei-Light;
          background: url("../../assets/images/parallelSessions/date-line-pc.png");
          background-repeat: no-repeat;
          background-position: center left;
        }
        &.active {
          color: #b4251e;
          border-left: 3px solid #b4251e;
        }
      }
    }
    .agenda-list-box {
      width: 1500px;
      margin-top: 20px;
      .agenda-type-list-pc {
        flex: 1;
        margin-right: 20px;
        height: 660px;
        background: linear-gradient(
          322deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0.35) 100%
        );
        border: 2px solid #ffffff;
        .agenda-type {
          cursor: pointer;
          width: calc(100% + 4px);
          margin-left: -2px;
          display: flex;
          height: 84px;
          align-items: center;
          position: relative;
          border-bottom: 1px solid rgba(198, 210, 233, 0.5);
          padding-left: 35px;
          font-size: 18px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #999999;

          &.active {
            font-size: 18px;
            color: #b4251e;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            background: url("../../assets/images/parallelSessions/active-bg-pc.png"),
              url("../../assets/images/parallelSessions/active-arrow-pc.png");
            background-repeat: no-repeat;
            background-position: 0 0, 210px 32px;
            .active-border {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 3px;
              background: #c7000b;
            }
          }
        }
        @media screen and (-ms-high-contrast: active),
          (-ms-high-contrast: none) {
          /*兼容IE11*/
          .agenda-type {
            cursor: pointer;
            width: calc(100% + 4px);
            margin-left: -2px;
            display: flex;
            height: 84px;
            align-items: center;
            position: relative;
            border-bottom: 2px solid rgba(198, 210, 233, 0.5);
            padding-left: 35px;
            font-size: 18px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;
            color: #999999;

            &.active {
              font-size: 18px;
              color: #b4251e;
              font-family: Microsoft YaHei-Bold;
              font-weight: bold;
              background: url("../../assets/images/parallelSessions/active-bg-pc.png"),
                url("../../assets/images/parallelSessions/active-arrow-pc.png");
              background-repeat: no-repeat;
              background-position: 0 0, 210px 32px;
              .active-border {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 3px;
                background: #c7000b;
              }
            }
          }
        }
      }

      .agenda-list-container {
        width: 1200px;
        height: 660px;
        .special-container {
          height: 100%;
          width: 100%;
          background: rgba(255, 255, 255, 0.4);
          border: 1px solid;
          border-image: linear-gradient(
              164deg,
              rgba(255, 255, 255, 1),
              rgba(235, 235, 235, 0)
            )
            1 1;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          .news-content {
            background: none;
            background-image: none;
            border: 0;
          }

          .special-box {
            height: 100%;
            display: flex;
            flex-direction: column;
            .item-box {
              height: 100px;
              background: rgba(255, 255, 255, 0.4);
              border: 1px solid;
              border-image: linear-gradient(
                  164deg,
                  rgba(255, 255, 255, 1),
                  rgba(235, 235, 235, 0)
                )
                1 1;
              position: relative;
              display: flex;
              justify-content: space-between;
              border-bottom: 1px solid #ececec;
              padding: 20px 30px;

              .item-content {
                flex: 1;
                padding-right: 18px;
                .title {
                  color: #151e26;
                  font-size: 18px;
                  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                  font-weight: bold;
                }

                .content {
                  padding-top: 6px;
                  font-size: 14px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #666666;
                  .time {
                    width: 150px;
                  }
                  .icon {
                    flex-shrink: 0;
                    width: 16px;
                    height: 16px;
                    margin-right: 9px;
                    border-radius: 50%;
                  }
                  .start_icon {
                    margin-top: 4px;
                  }
                  .text {
                    font-size: 16px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;

                    color: #666666;
                    line-height: 24px;
                  }

                  .address {
                    margin-left: 24px;
                  }
                }
              }
            }

            .item-content-box {
              flex: 1;
              overflow-y: auto;
              padding-left: 30px;
              padding-right: 30px;
              margin-bottom: 20px;

              .agenda-list {
                .agenda {
                  min-height: 82px;
                  display: flex;
                  justify-content: flex-start;
                  flex-direction: row;
                  .agenda-time-box {
                    padding-top: 26px;
                    padding-bottom: 26px;
                    height: 72px;
                    justify-content: center;
                    align-items: flex-start;
                    display: flex;
                    .agenda-time {
                      width: 224px;
                      font-size: 18px;
                      font-family: Microsoft YaHei-Bold;
                      font-weight: 900;

                      color: #151e26;
                      display: flex;
                      align-items: center;
                      padding-right: 20px;

                      .dot {
                        width: 15px;
                        height: 15px;
                        background: #f5fbfe;
                        opacity: 1;
                        border: 3px solid #b4251e;
                        border-radius: 50%;
                        margin-right: 30px;
                      }
                    }
                    .title {
                      display: flex;
                      align-items: flex-start;
                      width: 472px;
                      padding-right: 18px;
                      height: 100%;
                      font-size: 18px;
                      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                      font-weight: 400;
                      color: #151e26;
                      line-height: 30px;
                      margin-left: 40px;
                    }
                  }
                  .agenda-content {
                    flex: 1;
                    display: flex;
                    flex-direction: row;
                    align-items: flex-start;
                    justify-content: space-between;
                    border-bottom: 1px solid #e3e3e3;
                    .title {
                      width: 520px;
                      height: 100%;
                      padding-top: 26px;
                      padding-bottom: 26px;
                      min-height: 72px;
                      display: flex;
                      align-items: flex-start;
                      font-size: 18px;
                      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                      font-weight: 400;
                      color: #151e26;
                      padding-right: 10px;
                      .between {
                        display: inline-block;
                        width: 3em;
                        text-align-last: justify;
                      }
                    }

                    .child-list {
                      flex: 1;
                      padding-left: 20px;
                      height: 100%;

                      .peoples {
                        padding-top: 26px;
                        padding-bottom: 26px;
                        .people {
                          margin: 0;
                          .info {
                            font-size: 16px;
                            font-family: Microsoft YaHei-Regular,
                              Microsoft YaHei;
                            font-weight: 400;
                            color: #666666;
                            line-height: 24px;
                            display: flex;

                            .name {
                              width: 60px;
                              color: #666666;
                              margin-left: 22px;
                              .between {
                                display: inline-block;
                                width: 3em;
                                text-align-last: justify;
                              }
                            }
                            .postiton {
                              flex: 1;
                              font-size: 14px;
                              overflow: hidden;
                              color: #999999;
                              line-height: 24px;
                              margin-left: 22px;
                            }
                          }

                          & + .people {
                            .info {
                              margin-top: 10px;
                            }
                          }
                        }
                      }
                    }
                  }
                  @media screen and (-ms-high-contrast: active),
                    (-ms-high-contrast: none) {
                    .agenda-content {
                      flex: 1;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: space-between;
                      border-bottom: 2px solid #e3e3e3;
                      .title {
                        width: 380px;
                        padding-top: 26px;
                        padding-bottom: 26px;
                        min-height: 72px;
                        display: flex;
                        align-items: flex-start;
                        font-size: 18px;
                        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                        font-weight: 400;
                        color: #151e26;
                        padding-right: 10px;
                        .between {
                          display: inline-block;
                          width: 3em;
                          text-align-last: justify;
                        }
                      }

                      .child-list {
                        flex: 1;
                        padding-left: 20px;

                        .peoples {
                          padding-top: 26px;
                          padding-bottom: 26px;
                          .people {
                            margin: 0;
                            .info {
                              font-size: 16px;
                              font-family: Microsoft YaHei-Light;
                              font-weight: 400;
                              margin-bottom: 10px;
                              color: #666666;
                              line-height: 24px;
                              display: flex;
                              .name {
                                width: 60px;
                                color: #666666;
                                margin-left: 22px;
                                .between {
                                  display: inline-block;
                                  width: 3em;
                                  text-align-last: justify;
                                }
                              }
                              .postiton {
                                flex: 1;
                                font-size: 14px;
                                overflow: hidden;
                                color: #999999;
                                line-height: 24px;
                                margin-left: 22px;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }

                .agenda:last-child .agenda-content {
                  border: none;
                }
              }
            }
          }
        }
      }
    }
    .tips {
      padding-top: 10px;
    }
  }
}

@media (max-width: 992px) {
  [class$="-pc"] {
    display: none;
  }
  .overflowx {
    overflow-x: scroll;
  }
  .unset-min-width {
    min-width: unset !important;
  }
  .agenda-box {
    margin-top: 60px;
    padding-left: 35px;
    .agenda-top {
      font-size: 28px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #151e26;
      padding-bottom: 15px;
      background: url("../../assets/images/parallelSessions/title-border-wap.png");
      background-size: 117px 4.5px;
      background-repeat: no-repeat;
      background-position: left bottom;
    }
    .agenda-date-tabs {
      margin-top: 38px;
      //padding-bottom: 20px;
      .agenda-date-tab {
        color: #999999;
        height: 48px;
        padding-left: 12px;

        &:not(:first-child) {
          margin-left: 48px;
        }
        .day {
          height: 100%;
          font-size: 52px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: 900;
        }
        .month {
          margin-left: 5px;
          padding-left: 26px;
          height: 100%;
          font-size: 20px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          background: url("../../assets/images/parallelSessions/date-line-wap.png");
          background-size: 20px 48px;
          background-repeat: no-repeat;
          background-position: center left;
        }
        &.active {
          color: #b4251e;
          border-left: 5px solid #b4251e;
          .month {
            color: #b4251e;
          }
        }
      }
    }
    .agenda-list-box {
      //margin-top: 30px;
      flex-direction: column;

      .agenda-type-list-wap {
        font-size: 28px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        width: calc(100vw - 70px);
        color: #999999;
        margin-top: 30px;
        height: 106px;
        background-image: url("../../assets/images/partner/pc/tabs-bg.png");
        background-repeat: no-repeat;
        background-size: calc(100vw - 70px) 106px;
        border: 1px solid;
        border-image: linear-gradient(
            7deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.62)
          )
          2 2;
        filter: blur(undefinedpx);
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;

        //&::-webkit-scrollbar {
        //  display: none;
        //}
        .agenda-type-box {
          display: flex;
          min-width: calc(100vw - 68px);
          .agenda-type {
            padding-left: 40px;
            padding-right: 20px;
            flex-shrink: 0;
            //width: 194px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            position: relative;
            .active-bottom {
              position: absolute;
              bottom: 0;
              left: calc(50% - 45px + 10px);
              width: 90px;
              height: 4px;
              background: #b4251e;
              display: none;
            }
            .tab-bg {
              position: absolute;
              top: 0;
              left: -14px;
              background: url("../../assets/images/partner/wap/tab-bg.png");
              background-size: 100% 100%;
              width: 154px;
            }
            .active-bg {
              display: none;
              z-index: 1;
              pointer-events: none;
            }
            &.active {
              font-size: 28px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #b4251e;
              .active-bg {
                display: block;
              }
              .active-bottom {
                display: block;
              }
            }
            &:first-child {
              .tab-bg {
                display: none;
                z-index: 2;
              }
              .active-bg {
                position: absolute;
                top: -2px;
                left: -2px;
                width: calc(100% + 20px);
                height: calc(100% + 2px);
                background: url("../../assets/images/partner/wap/first-active-bg.png");
                background-size: calc(100% + 20px) 104px;
                display: block;
              }
            }
            & + .agenda-type {
              padding-left: 60px;
              .active-bg {
                position: absolute;
                top: -2px;
                right: -22px;
                width: calc(100% + 20px);
                height: calc(100% + 2px);
                background: url("../../assets/images/partner/wap/active-bg.png");
                background-size: calc(100% + 20px) 104px;
              }
            }
          }
        }

        .agenda-type:last-child {
          //width: 234px;
          //padding-right: 40px;
        }
      }
      .agenda-type-list-wap::-webkit-scrollbar {
        display: none; /*隐藏滚动条*/
      }
      .agenda-list-container {
        margin-top: 27px;
        width: calc(100vw - 70px);
        background: rgba(255, 255, 255, 0.4);
        .special-container {
          width: 100%;
          background: rgba(255, 255, 255, 0.4);
          border: 1px solid;
          border-image: linear-gradient(
              164deg,
              rgba(255, 255, 255, 1),
              rgba(235, 235, 235, 0)
            )
            1 1;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          .news-content {
            background: none;
            background-image: none;
            border: 0;
          }

          .special-box {
            display: flex;
            flex-direction: column;
            .item-box {
              width: 650px;
              background: rgba(255, 255, 255, 0.4);
              opacity: 1;
              border: 1px solid;
              border-image: linear-gradient(
                  164deg,
                  rgba(255, 255, 255, 1),
                  rgba(235, 235, 235, 0)
                )
                1 1;

              position: relative;
              display: flex;
              justify-content: space-between;
              border-bottom: 1px solid #ececec;
              padding: 30px;

              .item-content {
                flex: 1;
                padding-right: 18px;
                .title {
                  font-size: 28px;
                  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                  font-weight: bold;
                  color: #151e26;
                  line-height: 45px;
                }

                .content {
                  padding-top: 9px;
                  font-size: 22px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #666666;
                  .time {
                    width: 160px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                  .icon {
                    flex-shrink: 0;
                    width: 23px;
                    margin-right: 10px;
                  }
                  .start_icon {
                    width: 24px;
                  }
                  .text {
                    font-size: 22px;
                    font-family: Microsoft YaHei-Regular;
                    font-weight: 400;
                    color: #666666;
                    line-height: 36px;
                  }
                  .address {
                    margin-left: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                }
              }
            }

            .item-content-box {
              flex: 1;
              //overflow-y: auto;
              margin-top: 13px;
              padding-left: 30px;
              margin-bottom: 61px;

              .agenda-list {
                .agenda {
                  min-height: 191px;
                  display: flex;
                  justify-content: flex-start;
                  flex-direction: column;
                  align-items: self-start;
                  .agenda-time-box {
                    padding-top: 32px;
                    justify-content: center;
                    align-items: flex-start;
                    display: flex;
                    .agenda-time {
                      font-size: 24px;
                      font-family: Microsoft YaHei-Bold;
                      font-weight: 900;
                      color: #151e26;
                      display: flex;
                      align-items: center;
                      padding-right: 20px;
                      line-height: 48px;

                      .dot {
                        width: 15px;
                        height: 15px;
                        background: #f5fbfe;
                        opacity: 1;
                        border: 2px solid #b4251e;
                        border-radius: 50%;
                        margin-right: 28px;
                      }
                    }
                  }
                  .agenda-content {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-between;
                    width: calc(100% + 2px);
                    overflow-x: hidden;

                    .title {
                      display: flex;
                      align-items: flex-start;
                      font-size: 24px;
                      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                      font-weight: 400;
                      color: #151e26;
                      line-height: 45px;
                      margin-left: 40px;
                      padding: 10px 18px 16px 0;
                    }

                    .child-list {
                      margin-left: 20px;

                      width: 600px;

                      .peoples {
                        padding-left: 22px;
                        .people {
                          margin: 0;
                          .info {
                            padding-bottom: 15px;
                            font-size: 24px;
                            font-family: Microsoft YaHei-Light;
                            font-weight: 400;

                            color: #666666;
                            line-height: 34px;
                            display: flex;
                            & + .info {
                              margin-top: 10px;
                            }
                            .name {
                              width: 100px;
                              color: #666666;

                              .between {
                                display: inline-block;
                                width: 3em;
                                text-align-last: justify;
                              }
                            }
                            .postiton {
                              width: calc(100% - 150px);
                              font-size: 22px;
                              overflow: hidden;
                              color: #999999;
                              line-height: 34px;
                            }
                          }
                          &:last-child {
                            padding-bottom: 30px;
                            border-bottom: 1px solid rgba(187, 187, 187, 0.24);
                          }
                        }
                      }
                    }
                  }
                }
                :last-child {
                  .agenda-content {
                    .child-list {
                      .peoples {
                        .people {
                          &:last-child {
                            border-bottom: 1px solid transparent;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .tips {
      padding-top: 10px;
      padding-right: 35px;
    }
  }
}
</style>
